import CompanyList from "../../containers/admin-company-info/CompanyList";

type Props = {};

const CompanyInfo = (props: Props) => {
  return (
    <div>
      <CompanyList />
    </div>
  );
};

export default CompanyInfo;
